import { render, staticRenderFns } from "./gb-tinymce.vue?vue&type=template&id=05893f11&"
import script from "./gb-tinymce.vue?vue&type=script&lang=js&"
export * from "./gb-tinymce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports